// Tiny localStorage helpers for the Junior Crew micro-site.
// SSR-safe: guards window access.

function isBrowser() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function readSet(key: string): Set<string> {
  if (!isBrowser()) return new Set();
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return new Set();
    const arr = JSON.parse(raw) as string[];
    return new Set(Array.isArray(arr) ? arr : []);
  } catch {
    return new Set();
  }
}

export function writeSet(key: string, set: Set<string>) {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(Array.from(set)));
  } catch {
    // ignore
  }
}

export function toggleInSet(key: string, id: string): Set<string> {
  const s = readSet(key);
  if (s.has(id)) s.delete(id);
  else s.add(id);
  writeSet(key, s);
  return s;
}

export function addToSet(key: string, id: string): Set<string> {
  const s = readSet(key);
  s.add(id);
  writeSet(key, s);
  return s;
}

export function readJSON<T>(key: string, fallback: T): T {
  if (!isBrowser()) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeJSON<T>(key: string, value: T) {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore
  }
}

export const KEYS = {
  lessons: "jrcrew:lessons",
  knots: "jrcrew:knots",
  gear: "jrcrew:gear",
  safety: "jrcrew:safety-checklist",
  badges: "jrcrew:badges",
  log: "jrcrew:log",
  games: "jrcrew:games",
  gameBadges: "jrcrew:game-badges",
  conservation: "jrcrew:conservation",
} as const;

export function hasInSet(key: string, id: string): boolean {
  return readSet(key).has(id);
}